import { createShallowEqualSelector } from 'js/utils/redux.util';
import { useSelector as useReduxSelector, type TypedUseSelectorHook } from 'react-redux';

import { TRootState } from 'js/store/types';

export const useSelectorShallow: TypedUseSelectorHook<TRootState> = (selector, equalityFn) => {
    const shallowSelector = createShallowEqualSelector([selector], (data) => data);

    return useReduxSelector(shallowSelector, equalityFn);
};
